export const I18N_PREFIX = 'metrics_tab.insights_tab.topics_tab';

// Mirrors `topics_algo_version` on the /metrics/topics response. The two
// catalogs store different things, so the page renders a table per version.
export const TOPICS_V1 = 1;
export const TOPICS_V2 = 2;
